import { render, staticRenderFns } from "./BookingAssistant2.vue?vue&type=template&id=114820b5&scoped=true&lang=pug&"
import script from "./BookingAssistant2.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114820b5",
  null
  
)

export default component.exports